import { render, staticRenderFns } from "./MemberStatus.vue?vue&type=template&id=08d29f95&scoped=true&"
import script from "./MemberStatus.vue?vue&type=script&lang=js&"
export * from "./MemberStatus.vue?vue&type=script&lang=js&"
import style0 from "./MemberStatus.vue?vue&type=style&index=0&id=08d29f95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d29f95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
